module.exports = __webpack_public_path__ + "img/20210906-1630898441588146.6e25932f.jpg";